import { svgstore } from '../lib/svgstore'

// cta link
for (const el of document.querySelectorAll('.vp-block-cta > .container > a')) {
    el.innerHTML += svgstore('arrow-button')
}

// cta modal
for (const el of document.querySelectorAll('.vp-block-cta.has-modal')) {
    const modal = el.querySelector('.vp-modal')
    el.querySelector('.open-modal').addEventListener('click', (e) => {
        e.preventDefault()
        modal.classList.add('open')
    })
    for (const close of el.querySelectorAll('.close-modal, .overlay')) {
        close.addEventListener('click', () => {
            modal.classList.remove('open')
        })
    }
    const pre = modal.querySelector('pre')
    const content = modal.querySelector('.content')
    const code = pre?.textContent
    pre.remove()

    if (code && modal && content) {
        const iframe = document.createElement('iframe')
        content.appendChild(iframe)
        const doc = iframe.contentWindow.document
        iframe.addEventListener('load', () => {
            const docEl = doc.documentElement
            iframe.style.width = `${docEl.scrollWidth + 50}px`
            iframe.style.height = `${docEl.scrollHeight}px`
        })
        doc.open()
        doc.write(atob(code))
        doc.close()
    }
}
